/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coral_Bold_Crow_DrawInputs */

const en_coral_bold_crow_draw = /** @type {(inputs: Coral_Bold_Crow_DrawInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Peer Feedback`)
};

const de_coral_bold_crow_draw = /** @type {(inputs: Coral_Bold_Crow_DrawInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Peer Feedback`)
};

/**
* | output |
* | --- |
* | "Peer Feedback" |
*
* @param {Coral_Bold_Crow_DrawInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const coral_bold_crow_draw = /** @type {((inputs?: Coral_Bold_Crow_DrawInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coral_Bold_Crow_DrawInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_coral_bold_crow_draw(inputs)
	return de_coral_bold_crow_draw(inputs)
});